import script from "./MyPositions.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPositions.vue?vue&type=script&setup=true&lang=js"

import "./MyPositions.vue?vue&type=style&index=0&id=1bea9bda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bea9bda"]])

export default __exports__